module.exports = __webpack_public_path__ + "static/img/2.2e62ebf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wepb/2.webp
// module id = V6Kk
// module chunks = 1